document.addEventListener("DOMContentLoaded", function () {
  let starRatingElems = document.querySelectorAll(".star-rating");

  const setRating = (containerStars, rating, set = false) => {
    const starElems = containerStars.querySelectorAll(".star-rating__star");

    starElems.forEach((starElem) => {
      const starFilled = starElem.querySelector(".star-rating__star-filled");
      const starDataRating = starElem.dataset.rating;
      if (starDataRating < Math.floor(rating)) {
        starFilled.style.width = "100%";
      } else if (starDataRating == Math.floor(rating)) {
        const calcWidth = (rating % 1) * 100;
        starFilled.style.width = calcWidth + "%";
      } else {
        starFilled.style.width = "0";
      }
    });
  };

  starRatingElems.forEach((starRating) => {
    let starParts = starRating.querySelectorAll(".star-rating__star-part");

    const initialRating = starRating.dataset.rating;
    if (initialRating) {
      setRating(starRating, initialRating);
    }

    if (starRating.dataset.voting) {
      starParts.forEach((part) => {
        const selectedRating = part.dataset.rating;
        part.addEventListener("mouseover", () => {
          setRating(starRating, selectedRating);
        });

        part.addEventListener("click", () => {
          starRating.setAttribute("data-rating", selectedRating);
          starRating.removeAttribute("data-voting");
        });
      });
    }
  });
});
